import { createContext, useReducer } from 'react';

const isAuthorized = (): boolean => {
  const tokenString = sessionStorage.getItem('token');
  if (!tokenString) return false;
  try {
    const userToken = JSON.parse(tokenString);
    return !!userToken?.token;
  } catch (err) {
    return false;
  }
};
const reducer = (state: any, action: any) => {
  switch (action.type) {
    case 'saveToken': {
      sessionStorage.setItem('token', JSON.stringify({ token: action.payload.token }));
      const authorized = isAuthorized();
      if (!authorized) sessionStorage.removeItem('token');
      return { ...state, authorized };
    }
    case 'removeToken': {
      sessionStorage.removeItem('token');
      return { ...state, authorized: false };
    }
  }
  return state;
};

const defaultState = { authorized: isAuthorized() };

export const AuthenticationContext = createContext<any>(defaultState);

export default function AuthenticationContextComponent({ children }: { children: any }) {
  const [{ authorized }, dispatch] = useReducer(reducer, defaultState);

  const saveToken = (userToken: string): void => {
    dispatch({ type: 'saveToken', payload: { token: userToken } });
  };
  const removeToken = (): void => {
    dispatch({ type: 'removeToken' });
  };

  return (
    <AuthenticationContext.Provider value={{ authorized, saveToken, removeToken }}>
      {children}
    </AuthenticationContext.Provider>
  );
}
